import * as React from 'react';

export class Renderers {
  preventEnter: boolean = false;
  enterEdit: (dataItem: any, field: string | undefined) => {};
  exitEdit: (dataItem?: any) => {};
  editFieldName: string;
  preventExit: boolean | undefined;
  preventExitTimeout: any;
  onActivateCellInput: (input: HTMLInputElement) => {};
  getColumnByCellIndex: (cellIndex: number) => any;
  isFieldEditable: (field: string) => undefined | boolean;

  constructor(enterEdit, exitEdit, editFieldName, onActivateCellInput, getColumnByCellIndex, isFieldEditable) {
    this.enterEdit = enterEdit;
    this.exitEdit = exitEdit;
    this.editFieldName = editFieldName;
    this.onActivateCellInput = onActivateCellInput;
    this.getColumnByCellIndex = getColumnByCellIndex;
    this.isFieldEditable = isFieldEditable;
  }

  /**
   * Getter for additional closed editor component properties
   * @param dataItem
   * @param cellField
   */
  getClosedEditableFieldProps = (dataItem, cellField) => ({
    onClick: () => {
      this.enterEdit(dataItem, cellField);
    },
    onFocus: () => {
      if (!this.preventEnter) {
        this.enterEdit(dataItem, cellField);
      }
    }
  })

  /**
   * Getter for additional opened editor component properties
   */
  getOpenedEditableFieldProps = () => ({
    ref: (td: HTMLTableCellElement) => {
      const input = td && td.querySelector('input');
      const activeElement = document.activeElement;
      this.onActivateCellInput(input);

      input?.addEventListener('blur', (event) => {
        this.exitEdit();
      });

      if (
        !input ||
            !activeElement ||
            input === activeElement ||
            !activeElement.contains(input)
      ) {
        return;
      }

      if (input.type === 'checkbox') {
        input.focus();
      } else {
        input.select();
      }
    }
  })

  /**
   * Renders grid row for editor or another grid cell field
   * @param {HTMLTableRowElement} trElement
   */
  rowRender = (trElement: React.ReactElement<HTMLTableRowElement>) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (e) => {
        const cellIndex = e.target?.cellIndex;
        const column = this.getColumnByCellIndex(cellIndex);
        this.preventExit = column?.editable;
        clearTimeout(this.preventExitTimeout);
        this.preventExitTimeout = setTimeout(() => {
          this.preventExit = undefined;
        });
      },
      onBlur: (e) => {
        let relatedTarget = e.relatedTarget;
        if (!this.preventExit) {
          let column: any;
          while (relatedTarget?.nodeName.toLowerCase() !== 'td' && relatedTarget?.parentElement) {
            relatedTarget = relatedTarget?.parentElement;
          }
          if (relatedTarget?.nodeName.toLowerCase() === 'td') {
            column = this.getColumnByCellIndex(relatedTarget.cellIndex);
            if (column) {
              column.isRelatedTarget = true;
            }
          }
        }
      }
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };
}
